<ng-container *ngIf="upgradeState$ | async as state">
  <ng-container *ngIf="(showLoading$ | async) || state === UpgradeBenefitsState.LOADING">
    <div class="relative loader" aria-live="polite" aria-busy="true">
      <h4 class="flex flex--center font-heading-3 ms-xxlarge-t ms-large-b">
        {{ 'LOYALTY.upgradeBenefits.loadingMessage' | finLocalization }}
      </h4>
      <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
    </div>
  </ng-container>
  <ng-container *ngIf="(showLoading$ | async) === false && state === UpgradeBenefitsState.ERROR">
    <fcom-notification
      class="error block ms-xxlarge-t ms-large-b"
      [iconName]="SvgLibraryIcon.INFO_BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'LOYALTY.upgradeBenefits.errorLoadingBenefitsMessage' | finLocalization }}
    </fcom-notification>
  </ng-container>
</ng-container>

<ng-container *ngIf="(showLoading$ | async) === false">
  <ng-container
    *ngIf="upgradeVouchers$ | async as upgradeVouchers"
    [ngTemplateOutlet]="benefitTemplate"
    [ngTemplateOutletContext]="{
      benefits: upgradeVouchers,
      benefitCategory: BenefitCategory.UPGRADE,
      benefitTitle: 'LOYALTY.upgradeBenefits.benefitsTitle' | finLocalization,
      noBenefitsText: 'LOYALTY.upgradeBenefits.noBenefits' | finLocalization,
    }"
  >
  </ng-container>

  <ng-container
    *ngIf="otherVouchers$ | async as otherVouchers"
    [ngTemplateOutlet]="benefitTemplate"
    [ngTemplateOutletContext]="{
      benefits: otherVouchers,
      benefitCategory: BenefitCategory.OTHER,
      benefitTitle: 'LOYALTY.upgradeBenefits.vouchersTitle' | finLocalization,
      noBenefitsText: 'LOYALTY.upgradeBenefits.noVouchers' | finLocalization,
    }"
  >
  </ng-container>
</ng-container>
<ng-template
  #benefitTemplate
  let-benefits="benefits"
  let-benefitCategory="benefitCategory"
  let-benefitTitle="benefitTitle"
  let-noBenefitsText="noBenefitsText"
>
  <div class="benefit-title" [ngClass]="{ 'ms-xxlarge-b': benefitCategory !== BenefitCategory.OTHER }">
    <h3 class="ms-large-b">{{ benefitTitle }}</h3>

    <ng-container
      [ngTemplateOutlet]="benefits.length > 0 ? benefitList : noBenefits"
      [ngTemplateOutletContext]="{ benefits, benefitCategory }"
    >
    </ng-container>

    <div *ngIf="benefitCategory === BenefitCategory.UPGRADE && benefits.length > 0">
      <span class="block ms-large-t font-body-1">
        <cms-unstyled-fragment
          [contentUrl$]="'LOYALTY.fragments.upgradeBenefits.callToAction.url' | finLocalization | finToObservable"
        ></cms-unstyled-fragment>
      </span>
    </div>
  </div>

  <ng-template #benefitList>
    <div class="benefit-list">
      <ng-container
        *ngFor="
          let voucher of benefits.slice(0, displayedVoucherCount$ | async);
          let i = index;
          let last = last;
          let count = count
        "
      >
        <fin-expand
          *finLet="voucher.vouchers.length === 1 as oneVoucher"
          [class.oneVoucher]="oneVoucher"
          [disabled]="oneVoucher"
          [class.rounded-top-large]="i === 0 && count !== 1"
          [class.rounded-large]="i === 0 && last"
          [class.border-bottom]="count === 1 || (last && count !== 1)"
          [ngClass]="{ 'rounded-bottom-large': last && count !== 1 }"
          class="block bold-type border-top border-left border-right"
          [key]="'types-and-conditions-expand-' + benefitCategory + i"
          [id]="'types-and-conditions-expand-' + benefitCategory + i"
          #expand
        >
          <div
            [class.oneVoucher]="oneVoucher"
            class="trigger nordic-blue-900-text ps-small-y ps-small-r white-bg flex voucher-group rounded-large"
            tabindex="-1"
          >
            <span class="flex-1 flex flex--middle">
              <span class="voucher-group-amount align-center">{{ voucher.amount }}</span>
              <span class="voucher-group-name font-body-1">{{ voucher.benefitName }}</span
              ><span
                *ngIf="voucher.changed"
                class="ms-medium-l ps-xxsmall medium-type alert-50-bg rounded-medium font-body-2"
                >{{ 'LOYALTY.upgradeBenefits.disturbanceLabel' | finLocalization }}</span
              >
            </span>
            <div *ngIf="oneVoucher; else multipleVouchers" class="voucher-group-expiration">
              <fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.INFO_BLOCK"></fcom-icon>
              <span class="font-body-2 regular-type"
                >{{ 'LOYALTY.upgradeBenefits.expiryText' | finLocalization }}&nbsp;</span
              >
              <span class="voucher-expiration font-body-2">{{ voucher.date | finDateFormat: 'DATE' }}</span>
            </div>
            <ng-template #multipleVouchers>
              <div class="voucher-group-expiry-details">
                <span class="dn-mobile medium-type font-body-2">{{
                  'LOYALTY.upgradeBenefits.expiryDetails' | finLocalization
                }}</span>
                <fcom-icon
                  class="rotate icon-medium ms-xxsmall-l icon-medium"
                  [class.rotate-active]="expand.isOpen$ | async"
                  [name]="SvgLibraryIcon.CHEVRON_DOWN"
                ></fcom-icon>
              </div>
            </ng-template>
          </div>
          <div class="content" [ngClass]="{ 'ps-xsmall-y ps-small-r font-body-2': voucher.vouchers.length > 1 }">
            <ng-container *ngFor="let v of voucher.vouchers">
              <div *ngIf="voucher.vouchers.length > 1" class="ps-xsmall-y font-body-2">
                <ng-container>
                  <span class="font-body-1 regular-type">{{ v.amount }}&nbsp;{{ v.productName }}</span>
                  <div class="voucher-row-expiration ps-xxsmall-t font-body-2">
                    <span class="regular-type">{{ 'LOYALTY.upgradeBenefits.expiryText' | finLocalization }}&nbsp;</span>
                    <span class="voucher-expiration">{{ v.date | finDateFormat: 'DATE' }}</span>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </fin-expand>
      </ng-container>
    </div>

    <div class="flex flex--end" *ngIf="displayedVoucherCount$ | async as displayedCount">
      <fcom-button
        *ngIf="benefitCategory === BenefitCategory.OTHER && benefits?.length > (displayedVoucherCount$ | async)"
        class="ms-large-t"
        [text]="'plus.transactionHistory.loadMore' | finLocalization"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
        (clickBtn)="displayedVoucherCount$.next(displayedCount + 3)"
        data-testid="upgrade-benefits-load-more-button"
      >
      </fcom-button>
    </div>
  </ng-template>

  <ng-template #noBenefits>
    <div>
      <p class="no-upgrades">
        {{ noBenefitsText }}
      </p>
      <div class="flex flex--end" *ngIf="benefitCategory === BenefitCategory.OTHER">
        <a [finLink]="finnairShopUrl" [external]="true" [openInNewTab]="true">
          <fcom-button
            class="ms-large-t"
            [text]="'LOYALTY.upgradeBenefits.finnairShopButtonText' | finLocalization"
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [icon]="{
              name: SvgLibraryIcon.ARROW_RIGHT,
              position: IconPosition.RIGHT,
            }"
            data-testid="finnair-shop-button"
          ></fcom-button>
        </a>
      </div>
    </div>
  </ng-template>
</ng-template>
